import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider, createTheme } from "@mantine/core";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router";

import "@mantine/core/styles.css";

import { createQueryClient } from "./api";
import { App } from "./App";
import { DomainsOverview } from "./routes/DomainsOverview";
import { PerDomain } from "./routes/PerDomain";
import { PerWallet } from "./routes/PerWallet";

const theme = createTheme({});

const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    children: [
      { index: true, element: <Navigate to="/domains" replace /> },
      { path: "domains", Component: DomainsOverview },
      { path: "domain/:domainId", Component: PerDomain },
      { path: "wallet/:scriptPubKey", Component: PerWallet },
    ],
  },
]);

const queryClient = createQueryClient();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("missing #root element");
}

createRoot(rootElement).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools buttonPosition="bottom-right" initialIsOpen={false} />
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
